import { addIcon } from '@iconify/vue'

/**
 * Custom CDP glyphs, registered into Iconify's runtime registry under the
 * `cdp:` prefix.
 *
 * Every icon surface in the design system takes an ICONIFY NAME — `AppButton`'s
 * `leadingIcon` / `trailingIcon` / `splitIcon`, `AppAlert`'s `icon`,
 * `AppStatCard`, `AppOptionRow`, `AppDetailSection`, … Registering a Figma glyph
 * here gives it a name like any heroicon, so it flows through all of them with
 * no new prop, no `#icon` slot, and no per-component `<img>` escape hatch.
 *
 * NOT the same thing as `helpers/icons.js`: that one holds raw SVG strings
 * rendered with `v-html` into bespoke markup. This file is for glyphs that need
 * to be addressable BY NAME from a design-system prop.
 *
 * Paths use `currentColor`, so one registration serves every colour the glyph
 * appears in (the blue desktop "Add tag" button and the gray mobile one are the
 * same icon) — the files under `assets/images/icons/` bake a literal stroke in
 * and need a copy per colour.
 *
 * Called once from `main.js`, before the app mounts.
 */
const CDP_ICONS = {
  // Figma "Icons/tags" — the label/pennant outline used by every tag affordance
  // (Add tag button, tag chips, tag settings).
  'cdp:tags': {
    body: '<path d="M7.33333 2.66667H11.8433C13.47 2.66667 14.2833 2.66667 14.57 3.17733L14.5953 3.22533C14.854 3.75067 14.3933 4.42067 13.4713 5.76133C12.736 6.83067 12.368 7.36533 12.3593 7.97067V8.02933C12.368 8.63467 12.736 9.16933 13.4713 10.2387C14.3933 11.5787 14.854 12.2493 14.5953 12.7753L14.5707 12.822C14.284 13.3333 13.4707 13.3333 11.844 13.3333H7.33333C6.02466 13.3333 5.37066 13.3333 4.80733 13.052C4.24466 12.77 3.852 12.2467 3.06666 11.2C1.91133 9.65933 1.33333 8.88867 1.33333 8C1.33333 7.11133 1.91133 6.34067 3.06666 4.8C3.852 3.75333 4.24466 3.23 4.80733 2.948C5.37066 2.66667 6.02466 2.66667 7.33333 2.66667Z" fill="none" stroke="currentColor" stroke-width="1.5"/>',
    width: 16,
    height: 16,
  },
}

export const installCdpIcons = () => {
  Object.entries(CDP_ICONS).forEach(([name, icon]) => addIcon(name, icon))
}
